module.exports = __webpack_public_path__ + "img/henrikslide1.4e2531b7.png";